import { getInfCLogger } from '@infodata-group/inf-commons-core';
import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SubscriptionCounter } from './subscription-counter';

const logger = getInfCLogger('SubComponent');

@Directive()
export class SubComponent implements OnDestroy {
  protected _subs: Subscription[] = [];

  ngOnDestroy(): void {
    this._subs.forEach((x) => {
      SubscriptionCounter.counter++;
      x.unsubscribe();
    });
    logger.debug(
      `Total subscriptions destroyed from SubComponent: ${SubscriptionCounter.counter}`,
    );
  }
}
